export default "__VITE_ASSET__AwGYCaCm__"